import React from 'react';

import {
    withStyles,
    Snackbar,
} from '@material-ui/core';

const styles = (theme) => ({

});

class MSnackbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            snackopened: false,
            message: props.message ? props.message : '',
        };
    }

    show(message) {
        this.setState({ message: message, snackopened: true });
    }

    render() {
        const { snackopened, message } = this.state;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={snackopened}
                onClose={() => this.setState({ snackopened: false })}
                message={message}
                autoHideDuration={3000}>
            </Snackbar>
        );
    }
}

export default withStyles(styles)(MSnackbar);